<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/Buy/inspection/helmet.png",
          p: "AI移动巡检安全帽融合了先进的人工智能算法和智能设备功能，专为提升工地安全与管理效率而设计。通过安全隐患识别、质量隐患识别、物料验收识别、人员信息识别，并接入冰知识库及AI+智慧平台，实现全方位的智能巡检。除了核心识别功能外，安全帽还支持实时视频语音通话、群组视频通话、实时视频监控，并配备GPS定位、电子围栏、人员健康监测、有毒有害气体监测等功能。为了保障工地人员安全，安全帽还具备505报警、跌落报警、撞击报警、脱帽报警、静默报警、高温报警、近电感应、高度监测等多重安全预警功能，并可实现视频远程指导与可视化管理，为施工现场提供了全面的安全保障和智能化支持。",
          ref: "AI移动巡检安全帽",
        },
        {
          photoUrl: "../../../static/img/Buy/inspection/jiluyi.png",
          p: "将视觉大数据汇聚5G网络，以AI开启全场景智慧化应用，划时代的用“5G+AI”塑造了新一代5G记录仪，融入核心六大AI算法，同时兼顾支持安全隐患识别、质量隐患识别、物料验收识别、人员信息，并接入A1知识库及A1+智慧平台，实现全方位的智能巡检。",
          ref: "AI移动巡检记录仪",
        },
        {
          photoUrl: "../../../static/img/Buy/inspection/hezi.jpg",
          p: "AI超脑BOX，是一款智能软件算法和AI加速芯片相融合的微型服务器，32T超强算力，极高准确率，无误识别。 内置软件识别算法包括人脸、人体、车牌、车辆违停、烟雾烟火、佩戴安全帽、反光衣、安全带、安全绳、打电话、抽烟、工作服、离岗、睡岗、电瓶车、区域入侵、跌倒、摄像头遮挡、消防通道占用、静电释放、杂物堆积、油罐车、灭火器、打架、垃圾桶满溢、河道漂浮物监测等数十种。使用部署方便，可应用于加油站、化工厂、智慧社区、环保、工地、厂区、校园、园区、景区等场景。",
          ref: "AI超脑BOX",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 330px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: -32px;
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/inspection.vue